<div *ngIf="!hidden" class="p-field-checkbox" [class]="containerClass">
  <p-checkbox [(ngModel)]="value" binary="true" (click)="valueChangedEvent($event)" [disabled]="disabled || readonly"></p-checkbox>
  <div [class]="stateClass" (click)="handleLabelClickEvent()">
    <ng-content></ng-content>
  </div>
</div>
